function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

/** @todo (pablo) why do we have styles for a component live in a place completely different from where it's being defined */
import styles from 'common/query-builder/chart-customization/index.module.styl';
import { ButtonReact } from 'common/components/button';
import { ButtonLayout, ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { useTranslation } from 'common/i18n/hooks';
import { InputReact } from 'common/components/input';
import { InputSize } from 'common/components/input/types';
import { ToggleSize, ToggleTheme } from 'common/components/toggle/types';
import { ToggleReact } from 'common/components/toggle';
import { formatMetricNumberWithUnits } from 'common/util';
import { DropMenuReact } from 'common/components/drop-menu';
import { Directions, PositioningStrategy } from 'common/components/drop-menu/types';
import { AxisUnitOptions, AxisUnitPrecision, BEHAVIOR_METRIC_ABBREVIATION_DEFAULT, BehaviorMetricDisplay, BookmarkYAxisOptions } from 'common/report/insights/util/types';
import { ChartType, InsightsBookmarkParams } from 'common/types/reports/bookmark';
import { displayOptionsHaveChanged, getDisplayOptionsFromLineChartYAxisOptions, getMetricFormattingDefaultsFromQueryEntry, mergeDisplayOptions } from 'common/report/insights/charts/util';
import { EntryWithDisplay, MetricEntry, QueryEventEntry } from 'common/query-builder/query-entry-section/types';
import * as BookmarkTypes from 'common/types/reports/bookmark';
import { customPropertiesStore } from 'common/report/stores/custom-properties';
import { eventPropertyDefinitionsStore } from 'common/report/stores/property-definitions';
import { CLEAR_VALUE, PREFIX_SUFFIX_MAX_CHAR_COUNT, UNSET_VALUE } from '../axis/constants';
import { CallingLocation, track, TrackingEvent } from '../tracking';
import { ALL_PRESETS, CUSTOM_PRESET, DEFAULT_PRESET, PREFIX_PRESETS, PREVIEW_VALUE, SUFFIX_PRESETS } from './constants';
import { DecimalOption } from './decimal-option';
import { getToggleValue } from './util';
import metricUnitsStyles from './index.module.styl';
const getButtonValue = (prefix?: string, suffix?: string) => {
  return (prefix === null || prefix === void 0 ? void 0 : prefix[0]) || (suffix === null || suffix === void 0 ? void 0 : suffix[0]) || DEFAULT_PRESET;
};
const DecimalRow = (_ref: {
  currentDisplay: BehaviorMetricDisplay;
  defaults?: BehaviorMetricDisplay;
  entry: EntryWithDisplay;
  setEntry: (entry: EntryWithDisplay) => void;
  setAxis?: (axis: BookmarkYAxisOptions) => void;
}) => {
  var _ref2, _currentDisplay$preci;
  let {
    currentDisplay,
    defaults,
    entry,
    setEntry,
    setAxis
  }: {
    currentDisplay: BehaviorMetricDisplay;
    defaults?: BehaviorMetricDisplay;
    entry: EntryWithDisplay;
    setEntry: (entry: EntryWithDisplay) => void;
    setAxis?: (axis: BookmarkYAxisOptions) => void;
  } = _ref;
  const {
    t
  } = useTranslation();
  const precision = (_ref2 = (_currentDisplay$preci = currentDisplay.precision) !== null && _currentDisplay$preci !== void 0 ? _currentDisplay$preci : defaults === null || defaults === void 0 ? void 0 : defaults.precision) !== null && _ref2 !== void 0 ? _ref2 : CLEAR_VALUE;
  const setPrecision = (newPrecision: AxisUnitPrecision) => {
    if (setEntry) {
      const newClause = _objectSpread({}, entry);
      newClause.display = _objectSpread(_objectSpread({}, entry.display || {}), {}, {
        precision: newPrecision
      });
      setEntry(newClause);
    } else {
      setAxis === null || setAxis === void 0 || setAxis({
        axisUnit: {
          precision: newPrecision
        }
      });
    }
  };
  return <div className={clsx(styles.row, entry ? styles.short : undefined)} data-sentry-component="DecimalRow" data-sentry-source-file="index.tsx">
      <div style={{
      gridColumn: 1
    }}>
        <label className={styles.ccSublabel}>{t("chart-customization.decimals")}</label>
      </div>
      <div style={{
      gridColumn: 2
    }}>
        <DecimalOption precision={precision} setPrecision={setPrecision} isLeft data-sentry-element="DecimalOption" data-sentry-source-file="index.tsx" />
      </div>
      <div style={{
      gridColumn: 3
    }}>
        <DecimalOption precision={precision} setPrecision={setPrecision} isLeft={false} data-sentry-element="DecimalOption" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};
const AbbrevRow = (_ref3: {
  currentDisplay: BehaviorMetricDisplay;
  entry: EntryWithDisplay;
  setEntry: (clause: EntryWithDisplay) => void;
  setAxis: (axis: BookmarkYAxisOptions) => void;
}) => {
  var _currentDisplay$abbre;
  let {
    currentDisplay,
    entry,
    setEntry,
    setAxis
  }: {
    currentDisplay: BehaviorMetricDisplay;
    entry: EntryWithDisplay;
    setEntry: (clause: EntryWithDisplay) => void;
    setAxis: (axis: BookmarkYAxisOptions) => void;
  } = _ref3;
  const {
    t
  } = useTranslation();
  return <div className={clsx(styles.row, entry ? styles.short : undefined)} data-sentry-component="AbbrevRow" data-sentry-source-file="index.tsx">
      <div style={{
      gridColumn: 1
    }}>
        <label className={styles.ccSublabel}>{t("chart-customization.abbreviation")}</label>
      </div>
      <div className={styles.singleInputColumn}>
        <ToggleReact className={styles.singleInput} size={ToggleSize.Medium} theme={ToggleTheme.SegmentedController} options={[{
        label: t("common.yes"),
        value: "true"
      }, {
        label: t("common.no"),
        value: "false"
      }]} selected={String((_currentDisplay$abbre = currentDisplay.abbrev) !== null && _currentDisplay$abbre !== void 0 ? _currentDisplay$abbre : BEHAVIOR_METRIC_ABBREVIATION_DEFAULT)} onSelect={ev => {
        if (setEntry) {
          const newEntry = _objectSpread({}, entry);
          newEntry.display = _objectSpread(_objectSpread({}, entry.display || {}), {}, {
            abbrev: ev.detail.selected === "true"
          });
          setEntry(newEntry);
        } else {
          setAxis === null || setAxis === void 0 || setAxis({
            axisUnit: {
              abbrev: ev.detail.selected === "true"
            }
          });
        }
      }} data-sentry-element="ToggleReact" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};
const PreviewRow = (_ref4: {
  finalDisplay: BehaviorMetricDisplay;
  entry: EntryWithDisplay;
  onReset: (() => void) | null;
  onResetShown: boolean;
}) => {
  let {
    finalDisplay,
    entry,
    onReset,
    onResetShown = true
  }: {
    finalDisplay: BehaviorMetricDisplay;
    entry: EntryWithDisplay;
    onReset: (() => void) | null;
    onResetShown: boolean;
  } = _ref4;
  const {
    t
  } = useTranslation();
  const previewValue = formatMetricNumberWithUnits(PREVIEW_VALUE, finalDisplay);
  return <div className={clsx(styles.row, entry ? styles.short : undefined)} data-sentry-component="PreviewRow" data-sentry-source-file="index.tsx">
      <div style={{
      gridColumn: 1
    }}>
        <label className={styles.ccSublabel}>{t("chart-customization.preview")}</label>
      </div>
      <div className={styles.chartCustomizationPreview} style={{
      gridColumn: "2 / span 2"
    }}>
        <div className={styles.chartCustomizationPreviewText} style={{
        flex: "auto"
      }} title={previewValue}>
          {previewValue}
        </div>
        <div className={styles.chartCustomizationResetButton}>
          {onReset && <ButtonReact class={onResetShown ? "" : styles.hideResetButton} disabled={!onResetShown} layout={ButtonLayout.Horizontal} onClick={() => onReset()} size={ButtonSize.Small} theme={ButtonTheme.Tertiary}>
              {t("chart-customization.reset")}
            </ButtonReact>}
        </div>
      </div>
    </div>;
};
const MetricUnitRow = (_ref5: {
  elref?: string;
  currentDisplay: BehaviorMetricDisplay;
  defaults?: BehaviorMetricDisplay;
  entry?: EntryWithDisplay;
  setEntry?: (clause: EntryWithDisplay) => void;
  setAxis?: (axis: BookmarkYAxisOptions) => void;
}) => {
  var _defaults$prefix, _defaults$suffix;
  let {
    elref,
    currentDisplay,
    defaults,
    entry,
    setEntry,
    setAxis
  }: {
    elref?: string;
    currentDisplay: BehaviorMetricDisplay;
    defaults?: BehaviorMetricDisplay;
    entry?: EntryWithDisplay;
    setEntry?: (clause: EntryWithDisplay) => void;
    setAxis?: (axis: BookmarkYAxisOptions) => void;
  } = _ref5;
  const {
    t
  } = useTranslation();
  return <div className={clsx(styles.row, entry ? styles.short : undefined)} elref={elref} data-sentry-component="MetricUnitRow" data-sentry-source-file="index.tsx">
      <div style={{
      gridColumn: 1
    }}>
        <label className={styles.ccSublabel}>
          {t("chart-customization.prefix")} / {t("chart-customization.suffix")}
        </label>
      </div>
      <div style={{
      gridColumn: 2
    }}>
        <InputReact elref={"customPrefixInput"} ariaLabel={t("chart-customization.prefix")} className={styles.twoInputColumn} maxlength={PREFIX_SUFFIX_MAX_CHAR_COUNT} size={InputSize.Medium} placeholder={(_defaults$prefix = defaults === null || defaults === void 0 ? void 0 : defaults.prefix) !== null && _defaults$prefix !== void 0 ? _defaults$prefix : t("chart-customization.prefix")} value={currentDisplay.prefix || ""} onChange={ev => {
        if (setEntry) {
          const newEntry = _objectSpread({}, entry);
          newEntry.display = _objectSpread(_objectSpread({}, entry.display || {}), {}, {
            prefix: ev.detail.value || UNSET_VALUE
          });
          setEntry(newEntry);
        } else {
          setAxis === null || setAxis === void 0 || setAxis({
            axisUnit: {
              prefix: ev.detail.value || UNSET_VALUE
            }
          });
        }
      }} data-sentry-element="InputReact" data-sentry-source-file="index.tsx" />
      </div>
      <div style={{
      gridColumn: 3
    }}>
        <InputReact elref={"customSuffixInput"} ariaLabel={t("chart-customization.suffix")} className={styles.twoInputColumn} maxlength={PREFIX_SUFFIX_MAX_CHAR_COUNT} size={InputSize.Medium} placeholder={(_defaults$suffix = defaults === null || defaults === void 0 ? void 0 : defaults.suffix) !== null && _defaults$suffix !== void 0 ? _defaults$suffix : t("chart-customization.suffix")} value={currentDisplay.suffix || ""} onChange={ev => {
        if (setEntry) {
          const newEntry = _objectSpread({}, entry);
          newEntry.display = _objectSpread(_objectSpread({}, entry.display || {}), {}, {
            suffix: ev.detail.value || UNSET_VALUE
          });
          setEntry(newEntry);
        } else {
          setAxis === null || setAxis === void 0 || setAxis({
            axisUnit: {
              suffix: ev.detail.value || UNSET_VALUE
            }
          });
        }
      }} data-sentry-element="InputReact" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};
export function MetricUnitsButton(props: {
  callingLocation: CallingLocation;
  chartType?: ChartType;
  entry: EntryWithDisplay;
  insideFooter?: boolean | undefined;
  setEntry: (entry: EntryWithDisplay) => void;
  showDefaultMetricUnitSelector?: boolean;
  size?: ButtonSize | undefined;
  style?: React.CSSProperties;
}) {
  var _measurement, _props$entry, _props$entry2;
  const [propertyDisplayOptions, setPropertyDisplayOptions] = useState<BehaviorMetricDisplay>();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const updateProperty = () => {
    const property = "property" in props.entry ? props.entry.property : null;
    if (props.showDefaultMetricUnitSelector && property) {
      const customPropertyId = "customPropertyId" in property ? property.customPropertyId : null;
      if (customPropertyId) {
        var _customPropertiesStor;
        setPropertyDisplayOptions((_customPropertiesStor = customPropertiesStore.value[customPropertyId]) === null || _customPropertiesStor === void 0 ? void 0 : _customPropertiesStor.displayOptions);
      } else {
        const propertyValue = Array.isArray(property.value) ? property.value[0] : property.value;
        const propertyDefinition = eventPropertyDefinitionsStore.value[propertyValue];
        setPropertyDisplayOptions(propertyDefinition === null || propertyDefinition === void 0 ? void 0 : propertyDefinition.displayOptions);
      }
    } else {
      setPropertyDisplayOptions({});
    }
  };
  useEffect(() => {
    updateProperty();
  }, [(_measurement = (_props$entry = props.entry as MetricEntry) === null || _props$entry === void 0 ? void 0 : _props$entry.measurement) !== null && _measurement !== void 0 ? _measurement : (_props$entry2 = props.entry as QueryEventEntry) === null || _props$entry2 === void 0 ? void 0 : _props$entry2.property]);
  const defaultsFromEntry = getMetricFormattingDefaultsFromQueryEntry(props.entry);
  const mergedOptions: BehaviorMetricDisplay = mergeDisplayOptions(defaultsFromEntry, propertyDisplayOptions, props.entry.display);
  return <div className={styles.metricUnitsButton} data-sentry-component="MetricUnitsButton" data-sentry-source-file="index.tsx">
      <ButtonReact className={styles.unitSelectionButton} theme={ButtonTheme.Tertiary} pressed={isDropdownOpen} size={props.size || ButtonSize.Small} style={_objectSpread({
      '--button-content-width': props.insideFooter ? "reset" : undefined,
      '--button-justify-content': "center"
    }, props.style || {})} layout={ButtonLayout.Horizontal} onClick={() => setIsDropdownOpen(!isDropdownOpen)} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
        {getButtonValue(mergedOptions.prefix, mergedOptions.suffix)}
      </ButtonReact>

      {isDropdownOpen && <MetricUnitsSelectorDropdown open callingLocation={CallingLocation.Metric} chartType={props.chartType} entry={props.entry} propertyDisplay={propertyDisplayOptions} setEntry={props.setEntry} setOpen={open => setIsDropdownOpen(open)} />}
    </div>;
}
function MetricUnitsSelectorDropdown(props: {
  callingLocation: CallingLocation;
  entry: EntryWithDisplay;
  setEntry: (entry: EntryWithDisplay) => void;
  chartType?: ChartType;
  propertyDisplay?: BehaviorMetricDisplay;
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  return <DropMenuReact className={metricUnitsStyles.metricUnitsDropdown}
  // 340px fits the preview + reset button with {abbrev: false, precision: 8}
  style={{
    width: "340px"
  }} open={props.open} positionStrategy={PositioningStrategy.Fixed} direction={Directions.Down} forceStacking onChange={ev => {
    const opened = ev.detail.state === "open";
    props.setOpen(opened);
    if (opened) {
      track(TrackingEvent.OpenedMenu, props.callingLocation, {
        metricEntry: props.entry
      });
    }
  }} data-sentry-element="DropMenuReact" data-sentry-component="MetricUnitsSelectorDropdown" data-sentry-source-file="index.tsx">
      <div className={styles.metricSettingsBlock}>
        <MetricUnitsSelector callingLocation={props.callingLocation} entry={props.entry} setEntry={props.setEntry} chartType={props.chartType} data-sentry-element="MetricUnitsSelector" data-sentry-source-file="index.tsx" />
      </div>
    </DropMenuReact>;
}
export function MetricUnitsSelector(props: {
  axis?: BookmarkYAxisOptions;
  axisAssignment?: BookmarkTypes.AxisAssignment;
  bookmarkParams?: InsightsBookmarkParams;
  chartType?: ChartType;
  callingLocation: CallingLocation;
  defaultAxisOptions?: AxisUnitOptions;
  elref?: string;
  entry?: EntryWithDisplay;
  propertyDisplay?: BehaviorMetricDisplay;
  setEntry?: (entry: EntryWithDisplay) => void;
  setAxis?: (axis: BookmarkYAxisOptions) => void;
}) {
  const {
    t
  } = useTranslation();
  const defaultsFromEntry = props.entry ? getMetricFormattingDefaultsFromQueryEntry(props.entry, props.chartType) : {};
  // The inherited state from metric, property, or formula.
  const inheritedDisplay = props.entry ? mergeDisplayOptions({}, defaultsFromEntry, props.propertyDisplay) : props.defaultAxisOptions || {};
  // The actual current state.
  const currentDisplay = (props.entry ? props.entry.display : getDisplayOptionsFromLineChartYAxisOptions(props.axis)) || {};
  // The final merged state used for formatting.
  const finalMergedDisplay: BehaviorMetricDisplay = mergeDisplayOptions({}, inheritedDisplay, currentDisplay);
  const changedOptionPresent = displayOptionsHaveChanged({
    current: finalMergedDisplay,
    defaults: inheritedDisplay
  });
  const [preset, setPreset] = useState<string>();
  const setEntry = props.setEntry ? (entry: EntryWithDisplay) => {
    track(TrackingEvent.UpdatedUnits, CallingLocation.Metric, {
      metricEntry: entry
    });
    props.setEntry(entry);
  } : null;
  const setAxis = props.setAxis ? (axis: BookmarkYAxisOptions) => {
    track(TrackingEvent.UpdatedUnits, CallingLocation.Axis, {
      axis,
      axisAssignment: props.axisAssignment
    });
    props.setAxis(axis);
  } : null;
  useEffect(() => {
    setPreset(x => {
      if (x === CUSTOM_PRESET) {
        return x;
      }
      return getToggleValue(finalMergedDisplay.prefix, finalMergedDisplay.suffix);
    });
  }, [finalMergedDisplay.prefix, finalMergedDisplay.suffix, props.axis]);

  // Reset for axis is handled in the axis component
  const onReset = setEntry ? () => {
    track(TrackingEvent.Reset, props.callingLocation, {
      metricEntry: props.entry
    });
    const newEntry = _objectSpread({}, props.entry);
    newEntry.display = {};
    setEntry(newEntry);
  } : null;
  return <div elref={props.elref} data-sentry-component="MetricUnitsSelector" data-sentry-source-file="index.tsx">
      <div className={clsx(styles.row, props.entry ? styles.short : undefined)}>
        <div style={{
        gridColumn: 1
      }}>
          <label className={styles.ccSublabel}>{t("chart-customization.axis-unit")}</label>
        </div>
        <div className={styles.singleInputColumn} elref='metricUnitsToggle' style={{
        gridColumn: "2 / span 2"
      }}>
          <ToggleReact className={styles.singleInput} size={ToggleSize.Medium} theme={ToggleTheme.SegmentedController} options={ALL_PRESETS.map(unit => ({
          label: unit,
          value: unit
        }))} selected={preset} onSelect={ev => {
          var _props$entry3, _props$entry4;
          const selected = ev.detail.selected;
          setPreset(selected);
          let newPrefix = (_props$entry3 = props.entry) === null || _props$entry3 === void 0 || (_props$entry3 = _props$entry3.display) === null || _props$entry3 === void 0 ? void 0 : _props$entry3.prefix;
          let newSuffix = (_props$entry4 = props.entry) === null || _props$entry4 === void 0 || (_props$entry4 = _props$entry4.display) === null || _props$entry4 === void 0 ? void 0 : _props$entry4.suffix;
          if (PREFIX_PRESETS.includes(selected)) {
            newPrefix = ev.detail.selected;
            newSuffix = CLEAR_VALUE;
          } else if (SUFFIX_PRESETS.includes(selected)) {
            newPrefix = CLEAR_VALUE;
            newSuffix = ev.detail.selected;
          } else if (selected === DEFAULT_PRESET) {
            // When they select the default preset (#) we clear the values.
            newPrefix = CLEAR_VALUE;
            newSuffix = CLEAR_VALUE;
          } else if (selected === CUSTOM_PRESET) {
            // For Custom we use the unset value because we want inherited
            // values to take precedence until the user explicitly specifies
            // a custom unit.
            newPrefix = UNSET_VALUE;
            newSuffix = UNSET_VALUE;
          }
          if (setAxis) {
            const newAxis = {
              axisUnit: {
                prefix: newPrefix,
                suffix: newSuffix
              }
            };
            setAxis(newAxis);
            track(TrackingEvent.SelectedPreset, CallingLocation.Axis, {
              axis: newAxis,
              axisAssignment: props.axisAssignment,
              selectedPreset: selected
            });
          } else {
            const newEntry = _objectSpread(_objectSpread({}, props.entry), {}, {
              display: _objectSpread(_objectSpread({}, props.entry.display), {}, {
                prefix: newPrefix,
                suffix: newSuffix
              })
            });
            setEntry === null || setEntry === void 0 || setEntry(newEntry);
            track(TrackingEvent.SelectedPreset, CallingLocation.Metric, {
              metricEntry: newEntry,
              selectedPreset: selected
            });
          }
        }} data-sentry-element="ToggleReact" data-sentry-source-file="index.tsx" />
        </div>
      </div>
      {preset === CUSTOM_PRESET && <MetricUnitRow elref={"customPresetRow"} currentDisplay={currentDisplay} defaults={inheritedDisplay} entry={props.entry} setEntry={setEntry} setAxis={setAxis} />}
      <AbbrevRow currentDisplay={currentDisplay} entry={props.entry} setEntry={setEntry} setAxis={setAxis} data-sentry-element="AbbrevRow" data-sentry-source-file="index.tsx" />
      <DecimalRow currentDisplay={currentDisplay} defaults={inheritedDisplay} entry={props.entry} setEntry={setEntry} setAxis={setAxis} data-sentry-element="DecimalRow" data-sentry-source-file="index.tsx" />
      <PreviewRow finalDisplay={finalMergedDisplay} entry={props.entry} onReset={onReset} onResetShown={changedOptionPresent} data-sentry-element="PreviewRow" data-sentry-source-file="index.tsx" />
    </div>;
}